import { Drawer } from "@heroui/react";
import NetworkDetailsComp from "../network/network-details-comp";

const NetworkDetailsDrawer = ({ state, _connection_id, record, onRemoveConnectionResp }) => {
  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur" className="bg-black/30">
        <Drawer.Content placement="right">
          <Drawer.Dialog className={"min-w-[500px]"}>
            <Drawer.Body className="overflow-y-auto">
              <NetworkDetailsComp _connection_id={_connection_id} record={record} onRemoveConnection={onRemoveConnectionResp} />
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default NetworkDetailsDrawer;